<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToTableConfig'
});
</script>
<template>
	<div class="config">
		<to-icon ref="configIcon" value="config" color="info" mode="none" link @click="() => floatRef.value?.toggle(configIconRef.value)" />
		<to-float ref="floatRef" width="18" :lazy="false">
			<to-scroll padding="0.5">
				<to-tree show-checkbox check-strictly expand check-on-click-node :data="configData" value-text="label" :checked-keys="checked" @check-change="check" @node-expand="flex" @node-collapse="flex" />
			</to-scroll>
		</to-float>
	</div>
</template>

<script setup lang="ts">

import { ref, onMounted, watch } from 'vue'

const props = defineProps({
	data: { type: Array as () => any[], default: () => [] }
})
const emit = defineEmits(['change'])

const checked = ref<string[]>([])
const configData = ref<any[]>([])
const configIconRef = ref()
const floatRef = ref()

function setConfigData() {
	const data = JSON.parse(JSON.stringify(props.data))
	function setData(data: any[], path?: string[]) {
		data.forEach((dataItem, dataIndex) => {
			if (dataItem.type === 'selection' || dataItem.type === 'radio') {
				dataItem.label = '选择器'
			}
			if (dataItem.type === 'action') {
				data.splice(dataIndex, 1)
			}
			dataItem.path = path ? path.concat(dataItem.label) : [dataItem.label]
			if (dataItem.children) {
				setData(dataItem.children, dataItem.path)
			}
		})
	}
	setData(data)
	configData.value = data
}

function setChecked() {
	const arr: string[] = []
	function setData(data: any[]) {
		data.forEach(dataItem => {
			if (dataItem.show !== false) {
				if (dataItem.type === 'selection') {
					arr.push('选择器')
				} else {
					arr.push(dataItem.label)
				}
			}
			if (dataItem.children) {
				setData(dataItem.children)
			}
		})
	}
	setData(props.data)
	checked.value = arr
}

function flex() {
	floatRef.value?.set(configIconRef.value?.$el)
}

function check(checkedKeys: string[], checkedNodes: any, node: any, checkedFlag: boolean) {
	const data = JSON.parse(JSON.stringify(props.data))
	function checkData(data: any[]) {
		data.forEach(dataItem => {
			if (dataItem.type === 'selection') {
				dataItem.show = checkedKeys.includes('选择器')
			} else {
				dataItem.show = checkedKeys.includes(dataItem.label) || dataItem.type === 'action'
			}
			if (dataItem.children) {
				checkData(dataItem.children)
			}
		})
	}
	function setChildrenHide(data: any[], setHide: boolean) {
		data.forEach(dataItem => {
			if (setHide) {
				dataItem.show = false
				checked.value = checked.value.filter(item => item !== dataItem.label)
			}
			if (dataItem.children) {
				setChildrenHide(dataItem.children, dataItem.label === node.label || setHide)
			}
		})
	}
	function setChildrenAndParentShow(data: any[], setShow: boolean) {
		data.forEach(dataItem => {
			if (setShow || node.path.includes(dataItem.label)) {
				dataItem.show = true
				if (!checked.value.includes(dataItem.label)) {
					checked.value.push(dataItem.label)
				}
			}
			if (dataItem.children) {
				setChildrenAndParentShow(dataItem.children, dataItem.label === node.label || setShow)
			}
		})
	}
	checkData(data)
	if (!checkedFlag) {
		setChildrenHide(data, false)
		checked.value = checked.value.filter(item => item !== node.label)
	} else {
		setChildrenAndParentShow(data, false)
		checked.value.push(node.label)
	}
	emit('change', data)
}

onMounted(() => {
	setConfigData()
	setChecked()
})
watch(
	() => props.data,
	() => {
		setConfigData()
		setChecked()
	}
)
</script>
